import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api/axios.config';
import { notify } from '../utils/methods/notification';
import HospitalApi from '../../services/hospitalService';
import PhaseApi from '../../services/phase';
import ProductApi from '../../services/productService';


const initialState = {
    allOnBoardUser: [],
    allHospitalList: [],
    allProductList: [],
    allPhaseList: [],
    isLoading: false,
    addModal: false
};


// fetch the all roles data
export const fetchOnboardUser = createAsyncThunk(
    'roles/fetchOnboardUser',
    async (params, { rejectWithValue }) => {
        try {
            const response = await api.post('/acl/onboard-user/list',  params);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// add new user
export const addOnboardUser = createAsyncThunk(
    'roles/addOnboardUser',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { data, filters } = args;
            const response = await api.post('/acl/onboard-user/create', data);
            dispatch(disableAddModal())
            dispatch(fetchOnboardUser(filters))
            notify.success(response.data.message);
            return response.data;
        } catch (error) {
            notify.error(error ?? error.response.message);
            return rejectWithValue(error.response ? error.response.data : error);
        }
    }
);

// edit onboard user
export const editOnboardUser = createAsyncThunk(
    'roles/editOnboardUser',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { data, editId, filters } = args;
            const response = await api.put(`/acl/onboard-user/update/${editId}`, data);
            dispatch(disableAddModal())
            dispatch(fetchOnboardUser(filters))
            notify.success(response.data.message);
            return response.data;
        } catch (error) {
            notify.error(error ?? error.response.message);
            return rejectWithValue(error.response ? error.response.data : error);
        }
    }
);

// edit onboard user
export const deleteOnboardUser = createAsyncThunk(
    'roles/deleteOnboardUser',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { editId, filters } = args;
            const response = await api.delete(`/acl/onboard-user/${editId}`);
            dispatch(fetchOnboardUser(filters))
            notify.success(response.data.message);
            return response.data;
        } catch (error) {
            notify.error(error ?? error.response.message);
            return rejectWithValue(error.response ? error.response.data : error);
        }
    }
);

//fetch hospital list
export const fetchHospitalList = createAsyncThunk(
    'roles/fetchHospitalList',
    async (_, { rejectWithValue }) => {
        try {
            const response = await HospitalApi.getHospitalData('', 1, '');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error);
        }
    }
);
// fetch phase list
export const fetchPhaseList = createAsyncThunk(
    'roles/fetchPhaseList',
    async ({product_id,role_id}, { rejectWithValue }) => {
        try {
            const response = await PhaseApi.getPhaseList(product_id,'','',1,'',role_id);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error);
        }
    }
);
// fetch product list
export const fetchProductList = createAsyncThunk(
    'roles/fetchProductList',
    async (_, { rejectWithValue }) => {
        try {
            const response = await ProductApi.getProducts({ page: 1 });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error);
        }
    }
);

const onBoardUserSlice = createSlice({
    name: 'onBoardUser',
    initialState,
    reducers: {
        clearPhaseList(state) {
            state.allPhaseList = []
        },
        enableAddModal(state) {
            state.addModal = true
        },
        disableAddModal(state) {
            state.addModal = false
        },
    },
    extraReducers: (builder) => {
        /// handle fetch all user
        builder
            .addCase(fetchOnboardUser.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchOnboardUser.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allOnBoardUser = action.payload.data
            })
            .addCase(fetchOnboardUser.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle edit user
        builder
            .addCase(editOnboardUser.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(editOnboardUser.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(editOnboardUser.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle delete user
        builder
            .addCase(deleteOnboardUser.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteOnboardUser.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(deleteOnboardUser.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle add user
        builder
            .addCase(addOnboardUser.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(addOnboardUser.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(addOnboardUser.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle  fetchHospitalList
        builder
            .addCase(fetchHospitalList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchHospitalList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allHospitalList = action.payload
            })
            .addCase(fetchHospitalList.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle  fetchPhaseList
        builder
            .addCase(fetchPhaseList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchPhaseList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allPhaseList = action.payload
            })
            .addCase(fetchPhaseList.rejected, (state) => {
                state.isLoading = false;
            });
        /// handle fetchProductList
        builder
            .addCase(fetchProductList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchProductList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allProductList = action.payload
            })
            .addCase(fetchProductList.rejected, (state) => {
                state.isLoading = false;
            });
    },
});
export const { clearPhaseList, enableAddModal, disableAddModal } = onBoardUserSlice.actions

export const selectBmrOnBoardUserLoading = (state) => state.onBoardUser.isLoading;
export const selectBmrAllOnBoardUser = (state) => state.onBoardUser.allOnBoardUser;
export const selectBmrAllHospitalList = (state) => state.onBoardUser.allHospitalList;
export const selectBmrAllPhaseList = (state) => state.onBoardUser.allPhaseList;
export const selectBmrAllProductList = (state) => state.onBoardUser.allProductList
export const selectBmrAddModal = (state) => state.onBoardUser.addModal




export default onBoardUserSlice.reducer;
